import { mapState } from 'vuex';
import f from '@/application/shared/functions.js'
import datepicker from '@/components/assets/datepicker/index.vue';

export default {
    name: 'bday',
    props: {
        initial : Number
    },

    data : function(){

        return {
            loading : false,
            ages : [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17],
            icons : {1 : true,2 : true, 3 : true, 4 : true, 5 : true},
            value : null,
            observer : null,
            wasvalue : false,
            scrolling : false,
            emojies : ['😊', '😁', '❤️', '👍', '😜' , '😃', '☺️'],
            ready : false,
            showeddatepicker : false
        }

    },

    components : {
        datepicker
    },

    beforeDestroy (){
        this.destroyObserver()

        this.$store.commit('tempage', undefined)

    },

    created(){
        if(this.initial) this.value = this.initial

        if (this.userinfo?.bday){
            this.value = this.userinfo?.bday
        }


        if(!this.value){

            var fa = this.availableAges[0]

            if (fa == -1) fa = 3

            this.setValueByAge(fa)
        }
        else{
            this.wasvalue = this.value
        }

        setTimeout(() => {
            this.scrollToValue()
            this.createObserver()

            this.ready = true
        }, 30)

    },

    watch: {
        value : function(){

            var randomemoji = this.emojies[f.rand(0, this.emojies.length - 1)]

            if (this.ready){
                this.starsEffect({
                    size : 15,
                    duration : 2000
                })
            }
            
            this.$store.commit('tempage', this.value ? f.calculateAge(this.value) : undefined)

            /*this.emojieffect(randomemoji, {
                size : 20
            })*/
        }
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,
        userinfo : state => state.userinfo?.userinfo,

        nothingChanges : function(){

            if(!this.wasvalue) return false

            var dw = new Date(this.wasvalue.getFullYear(), this.wasvalue.getMonth(), this.wasvalue.getDate())
            var dv = new Date(this.value.getFullYear(), this.value.getMonth(), this.value.getDate())

            return dw.toString() == dv.toString()
            
        },

        availableAges : function(){
            return f.deep(this.core, 'appInfo.snippity.settings.age') || [-1, -1]
        },

        age : function(){
            return f.calculateAge(this.value)
        },

        canselectValue : function(){
            return this.canselectValueM(this.age)
        }
    }),

    methods : {
        canselectValueM : function(age){
            if(age >= this.availableAges[0] && age <= this.availableAges[1]){
                return true
            }

            return false
        },
        showdatepicker : function(){
            this.showeddatepicker = true
        },
        starsEffect : function(p = {}){
            if (this.core.infinityEffect){
                this.core.infinityEffect.play('stars', {
                    size : 15,
                    scatter : 100,
                    opacity : 0.8,
                    color : '#ffa000',
                    
                    from : {
                        y : window.innerHeight / 2,
                        x : window.innerWidth / 2
                    },

                    to : {
                        y : window.innerHeight,
                        x : window.innerWidth
                    },
                    ...p
                })
            }
        },

        emojieffect : function(symbol, {size, duration}){

            if (this.core.infinityEffect){
                this.core.infinityEffect.play('emoji', {
                    symbol,
                    size : size || 20,
                    scatter : window.innerWidth / 3,
                    duration : duration || 4000,
                    from : {
                        y : window.innerHeight,
                        x : 0
                    },

                    to : {
                        y : window.innerHeight / 2,
                        x : window.innerWidth / 2
                    }
                })
            }
        },
        setdate : function(){

            this.$store.commit('globalpreloader', true)

            this.core.user.infoEdit({
                info : {
                    bday : f.date.toserverFormatDate2(this.value, true)
                }
            }).then(() => {


                this.$emit('change', this.value)
                this.$emit('close')

            }).catch(e => {

                console.error(e)

                this.$store.commit('icon', {
					icon: 'error',
					message: this.$t(e.error || "errors.general")
				})

            }).finally(() => {
				this.$store.commit('globalpreloader', false)
			})
            
        },

        scrollToValue : function(){
            var age = Math.max(Math.min(f.calculateAge(this.value), 17), 1)

            if(this.$refs['age_' + age]?.[0]) {
                this.scroll(this.$refs['age_' + age][0].offsetTop - this.$refs['age_' + age][0].clientHeight / 2)
            }
        },

        destroyObserver : function() {
            if (this.observer){
                this.observer.disconnect()
                this.observer = null
            }
        },

       
        createObserver : function() {

            if(!this.$refs.bdayroot) return

            // создаем экземпляр IntersectionObserver
            this.observer = new IntersectionObserver((entries) => {

                entries.forEach((entry) => {



                    if (entry.isIntersecting && !this.scrolling) {
                        this.setValueByAge(entry.target.getAttribute('age'))
                    }
                });
                },
                {
                    threshold: 0.5,
                }
            );
          
            const sections = this.$refs.bdayroot.querySelectorAll(".age");

            sections.forEach((section) => this.observer.observe(section));
        },

        scroll(s) {
			const container = this.$refs["ages"];

            if(!container) return

            this.scrolling = true

			if (container.scrolling) {
				container.scrolling(-1, s);
			} else {
				container.scrollTop = s;
			}

            setTimeout(() => {
                this.scrolling = false
            }, 500)
		},
        
        setValueByAge : function(age){

            var d = null

            /*if (this.wasvalue){
                d = new Date((new Date()).getFullYear(), this.wasvalue.getMonth(), this.wasvalue.getDate())
            }
            else{
                d = new Date()
            }*/

                 d = new Date()
            
            d.setFullYear(d.getFullYear() - age);

            if(!this.value || (d.toString() != this.value.toString())){
                this.value = d
            }


        },

        cancel : function(){
            this.$emit('close')
        },
    },
}